import { all, takeEvery, put, call } from 'redux-saga/effects';
import { get } from 'lodash';
import actions from './actions';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';

const api = new Api('jobs/fulfillment');
const apiJob = new Api('jobs');

function* loadData({ payload }) {
  try {
    const { time_from, time_to, worker_id, company_id } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { time_from, time_to, worker_id, company_id } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const events = get(result, 'data.success.data.records', {});
      yield put(actions.loadDataSuccess({ events }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadJobs({ payload }) {
  try {
    const {
      pageSize = 10,
      page = 1,
      order = 'ascend',
      column = 'starts_at',
      start_date,
      worker_id,
      company_id,
      ...otherQuery
    } = payload;
    const result = yield call(
      sendRequest,
      apiJob.load,
      { search: { ...otherQuery, pageSize, page, order, column, start_date, worker_id, company_id } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const {
        records,
        totalCount,
        filteredCount: filteredTotal,
        sortableColumns,
        filters,
        saved_searches,
      } = result.data.success.data;
      yield put(
        actions.loadJobsSuccess({
          data: records,
          total: totalCount,
          filteredTotal,
          sortableColumns,
          filters,
          savedSearches: saved_searches,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}
export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.LOAD_JOBS, loadJobs)]);
}
